import React from 'react';
import './LeftSidebar.css';
import { registry } from '../registryData';
import { useTileStore } from '../contexts/SvgZoomContext';
import { FaGithub } from 'react-icons/fa';
import ProfileSection from './ProfileSection';

const LeftSidebar: React.FC<{
  children?: React.ReactNode;
  showRegistryMenu?: boolean;
}> = ({ children, showRegistryMenu = false }) => {
  const selectedTileGroup = useTileStore((state) => state.selectedTileGroup);
  const setSelectedTileGroup = useTileStore((state) => state.setSelectedTileGroup);
  const isAnimating = useTileStore((state) => state.isAnimating);

  const widthClass = 'width-px';

  const handleMenuClick = (groupKey: string) => {
    if (!isAnimating) setSelectedTileGroup(selectedTileGroup === groupKey ? null : groupKey);
  };

  // PROFILE SECTION HERE
  const profileSection = (
    <ProfileSection />
  );

  // MENU WITH PROFILE ABOVE THE SECTIONS
  const registryMenu = (
    <div className="registry-sidebar-content">

      {/* PROFILE FIRST */}
      {profileSection}

      <div style={{ 
        width: "100%", 
        height: "4px", 
        backgroundColor: "#000", 
        opacity: 0.3,
        margin: "12px 0" 
      }} />


      
      <div
        className="sidebar-description-container"
      >
        <p
          className="sidebar-description"
        >
          I am a software engineer with experience in Fullstack Development and AI
          infrastructure. On the side my hobbies are building websites, graphic
          design and painting.
        </p>
      </div>

      <div style={{ 
        width: "100%", 
        height: "4px", 
        backgroundColor: "#000", 
        opacity: 0.3,
        margin: "12px 0" 
      }} />

      
      <ul className="sidebar-nav registry-nav">
          {Object.entries(registry).map(([key, entry]) => {
            const isSelected = selectedTileGroup === key;
            const colorClass =
              entry['group-definition-texture'].includes('red') ? 'texture-red' :
              entry['group-definition-texture'].includes('blue') ? 'texture-blue' :
              entry['group-definition-texture'].includes('green') ? 'texture-green' :
              entry['group-definition-texture'].includes('yellow') ? 'texture-yellow' : 'texture-default';

            return (
              <li
                key={key}
                className={`registry-item${isSelected ? ' selected' : ''}${isAnimating ? ' disabled' : ''} ${colorClass}`}
                onClick={() => handleMenuClick(key)}
              >
                <div className="registry-item-indicator"></div>
                <span className="registry-item-text">{key.toUpperCase()}</span>
              </li>
            );
          })}

          <li className="blank-item" style={{ pointerEvents: 'none', background: 'transparent', borderColor: 'transparent' }}>
            <div className="registry-item-indicator" style={{ visibility: 'hidden' }}></div>
            <span className="registry-item-text" style={{ visibility: 'hidden' }}></span>
          </li>
        </ul>
    </div>
  );


  return (
    <div className={`left-sidebar ${widthClass}`}>
      <div className="sidebar-content">
        {showRegistryMenu ? registryMenu : children}
      </div>
    </div>
  );
};

export default LeftSidebar;
